export const ordersDefault = {
  orders: [],
  isProcessing: false,
  isQueried: false,
  isHexaOrderHistory: true,
}

const setOrders = (state, value) => {
  return { ...state, orders: value, isQueried: true }
}

const setIsProcessing = (state, value) => {
  return { ...state, isProcessing: value }
}

const ordersActions = {
  ORDERS: setOrders,
  IS_PROCESSING: setIsProcessing,
}

const ordersReducer = (state, action) => {
  return ordersActions[action.type](state, action.value)
}

export default ordersReducer
